import styled from 'styled-components/macro';

export const SelectsWrapper = styled.div`
    width: 80%;
    display: flex;
    position: relative;
    flex-wrap: wrap;
    gap: var(--space-sm);
`;
